import { component } from 'picoapp';
import { Slider } from './Slider';

export default component((node, ctx) => {
  // if (!customElements.get('slider-component')) {
  //   customElements.define('slider-component', Slider);
  // }
  new Slider(node, ctx);
});
